export default "__VITE_ASSET__ladCOqoG__"